import { expired_licenseService } from '../_services';

const state = { onRequest: false, expired_license: [] };

const actions = {
    get_data({ dispatch, commit }, data) {
        commit('request');

        expired_licenseService.get_data(data)
            .then(
                resp => {
                    commit('success_data', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    clear_data({ commit }) {
        commit('clear_data');
    },
};
const getters = {
  onRequest: state => {
    return state.onRequest
  },
  expired_license: state => {
    return state.expired_license
  },
};

const mutations = {
    request(state) {
        state.onRequest = true;
        state.expired_license = [];
    },
    success(state) {
      state.onRequest = false;
    },
    success_data(state, data) {
      state.onRequest = false;
      state.expired_license = data;
    },
    error(state) {
        state.onRequest = false;
    },
    clear_data(state) {
      state.onRequest = false;
      state.expired_license = [];
    },
};

export const expired_licenses = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
